import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';
import { FontSizes, FontWeights, LineHeights } from '../../../../../types/common/types';
import { ButtonColors, ButtonFontSizes, ButtonHeights, ButtonTypes } from '../../../../../ui/gzButton/types';

export const templateMdrContactDetailsSection = document.createElement('template');

templateMdrContactDetailsSection.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">

    <gz-title
      id="contact-details-section-title"
      class="form-subtitle"
      fontweight="${FontWeights.SEMIBOLD}"
      fontsize="${FontSizes.PARAGRAPH_11}"
      lineHeight="16.5px"
    ></gz-title>

    <gz-text
      id="contact-details-section-info"
      class="mt-2 mb-2 form-subtitle-info"
      fontWeight="${FontWeights.NORMAL}"
      fontSize="${FontSizes.PARAGRAPH_12}"
      lineHeight='${LineHeights.NORMAL}'
    ></gz-text>

    <gz-mdr-contact-import-options id="contact-details-import-options"></gz-mdr-contact-import-options>

    <gz-button
      id="contact-details-import-button"
      disabled="true"
      type="${ButtonTypes.OUTLINE}"
      color="${ButtonColors.PRIMARY}"
      buttonHeight="${ButtonHeights.SMALL}"
      buttonFontSize="${ButtonFontSizes.SMALL}"
      lowercase="true"
    ></gz-button>

    <gz-mdr-contact-details-form id="contact-details-form"></gz-mdr-contact-details-form>

    <gz-text
      id="contact-details-section-footer"
      class="mt-3 form-subtitle-info"
      fontWeight="${FontWeights.NORMAL}"
      fontSize="${FontSizes.PARAGRAPH_12}"
      lineHeight='${LineHeights.NORMAL}'
    ></gz-text>

  </div>
`;
